/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type BulkVersionUpdateAgentSkillPathParams = NonNullable<
  operations['bulkVersionUpdateAgentSkill']['parameters']['path']
>;

export type BulkVersionUpdateAgentSkillRequestBody = OperationRequestBodyContent<
  operations['bulkVersionUpdateAgentSkill']
>;

export interface Input extends BulkVersionUpdateAgentSkillPathParams {
  apiVersion?: string;
  body: BulkVersionUpdateAgentSkillRequestBody;
}

export async function bulkVersionUpdateAgentSkill(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/internal/projects/{projectKey}/ai-configs/skills/{skillKey}/bulk-version-update', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
